var map = {
	"./sch-1.jpg": 150,
	"./sch-2.jpg": 151,
	"./sch-3.jpg": 152,
	"./sch-4.jpg": 153,
	"./sch-5.jpg": 154,
	"./sch-6.jpg": 155,
	"./scholarship-1.jpg": 156,
	"./scholarship-2.jpg": 157,
	"./scholarship-3.jpg": 158,
	"./scholarship-4.jpg": 159,
	"./scholarship-5.jpg": 160,
	"./scholarship-6.jpg": 161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1392;